<template>
  <div class="inhalt" id="inhalt">
    <div class="desktop-inhalt">
      <div class="left">
        <div
          class="headline-box"
          v-scroll-reveal.reset="{
            delay: 250,
            distance: '250px',
            origin: 'left',
          }"
        >
          <div class="headline headline-redbox">Inhalt</div>
        </div>
        <div
          v-html="$texte.inhalt.text"
          v-scroll-reveal.reset="{ delay: 500 }"
        ></div>
      </div>
      <div class="right">
        <img
          class="picture"
          src="@/assets/images/inhalt/pic01.jpg"
          alt=""
          v-scroll-reveal.reset="{
            delay: 250,
            distance: '250px',
            origin: 'right',
          }"
        />
        <div class="picture-text" v-scroll-reveal.reset="{ delay: 600 }">
          Das Festspielhaus in Bayreuth
        </div>
        <div
          class="cite"
          v-scroll-reveal.reset="{
            delay: 800,
            distance: '250px',
            origin: 'right',
          }"
        >
          <img src="@/assets/images/allgemein/cite_sign.png" alt="" />
          <div class="text">
            Bayreuth ist einfach<br />
            der beste Platz auf der Welt,<br />
            um Wagners Werk zu erleben.<br />
            <span>ALEX ROSS, US-MUSIKKRITIKER</span>
          </div>
        </div>
      </div>
    </div>
    <div class="horizontal"></div>
  </div>
</template>

<script>
export default {
  inject: ['kinostart'],
}
</script>

<style lang="scss" scoped>
.inhalt {
  background-color: var(--clr-blau);
  overflow-x: hidden;
  .horizontal {
    margin-top: 20px;
  }
  .desktop-inhalt {
    position: relative;
    max-width: 1024px;
    display: flex;
    color: white;
    margin-inline: auto;
    padding-block: 1em;
    .left {
      padding-top: 3em;
      text-align: right;
      padding-left: 1.5em;
      width: 464px;
      .headline-box {
        position: absolute;
        z-index: 1;
        top: 10px;
        left: 50%;
        transform: translateX(-100%);
        margin-left: 20px;
        width: 1280px;
        border-bottom: 1px solid white;
        text-align: right;
        .headline-redbox {
          padding-right: 4rem;
        }
      }
    }
    .right {
      width: 560px;
      padding-top: 410px;
      padding-left: 2em;
      .picture-text {
        padding-left: 10px;
      }
      .cite {
        margin-top: 40px;
        display: flex;
        font-size: 1.6rem;
        img {
          align-self: flex-start;
        }
        .text {
          margin-top: 25px;
          margin-left: 15px;
          span {
            font-size: 0.9rem;
            color: var(--clr-red);
          }
        }
      }
      .picture {
        position: absolute;
        z-index: 0;
        top: 0;
        left: 495px;
        width: 702px;
        height: 421px;
      }
    }
  }
}
</style>
